import { render } from "./SetNicknameModal.vue?vue&type=template&id=1823bf6e"
import script from "./SetNicknameModal.vue?vue&type=script&lang=js"
export * from "./SetNicknameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__